import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Pagination } from "swiper";
import { KeypointCart } from "./KeypointCart";

export const KeypointSwip = ({ keypoints }) => {
  return (
    <Swiper
      slidesPerView={1}
      centeredSlides={false}
      spaceBetween={20}
      pagination={{
        clickable: true,
      }}
      modules={[Pagination]}
      className="keypoints"
    >
      {keypoints?.map((keypoint) => (
        <SwiperSlide key={keypoint?.order}>
          <KeypointCart keypoint={keypoint} length={keypoints?.length} />
        </SwiperSlide>
      ))}
    </Swiper>
  );
};
